import React, { Suspense } from 'react';
import ChunkErrorBoundary from './ChunkErrorBoundary';

/**
 * A reusable wrapper for lazy-loaded components that prevents re-rendering issues
 * and provides consistent loading states across the application.
 */
const LazyComponentWrapper = ({
  component: Component,
  fallbackText = 'Loading...',
  customFallback = null,
  componentProps = {},
  source = 'unknown-lazy-component',
  errorFallback = null,
  children,
  ...otherProps
}) => {
  const fallback = customFallback || (
    <div
      className="ltFormContainer"
      role="status"
      aria-live="polite"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100px',
      }}
    >
      {fallbackText}
    </div>
  );

  return (
    <ChunkErrorBoundary source={source} errorFallback={errorFallback}>
      <Suspense fallback={fallback}>
        <Component {...componentProps} {...otherProps}>
          {children}
        </Component>
      </Suspense>
    </ChunkErrorBoundary>
  );
};

export default LazyComponentWrapper;
